import React, { useEffect, useMemo } from "react";
import TaxStrategySection from "../client_details/TaxStrategySection";
import { useClientCategoryTab } from "../../hooks/useClientCategoryTab";
import "../client_details/clientDetails.scss";
import "./tax_strategy.scss";

const ClientTaxStrategy = () => {
  const loggedInUserId = localStorage.getItem("user_id");
  const userRole = (localStorage.getItem("user_role") || "client").toLowerCase();

  const {
    categoryTab,
    syncClientType,
  } = useClientCategoryTab();

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("USER_DATA") || "{}");
      syncClientType(userData.client_type);
    } catch {
      /* ignore */
    }
  }, [syncClientType]);

  const clientData = useMemo(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("USER_DATA") || "{}");
      if (!Object.keys(userData).length) return null;
      return {
        ...userData,
        client_id: userData.client_id || loggedInUserId,
      };
    } catch {
      return null;
    }
  }, [loggedInUserId]);

  return (
    <div className="client-tax-strategy-page">
      <TaxStrategySection
        clientId={loggedInUserId}
        clientData={clientData}
        activeEmployees={[]}
        loggedInUserId={loggedInUserId}
        userRole={userRole}
        category={categoryTab}
      />
    </div>
  );
};

export default ClientTaxStrategy;
